import React, { useEffect, useState } from 'react';
import { HomefieldIconSignCancel, HomefieldIconTimeHistory } from '@dsg-tech/homefield-react-icons';
import { TextLink } from '@dsg-tech/homefield-react';
import { StoreIdentifierName } from 'types';
import { multiUseAnalyticsEvent } from 'utility/analytics-events';
import { setCookie } from 'utility/cookie-utils';
import { NEW_KEY_CODES } from 'utility/constants';
import getSearchUtils from '../SearchUtils';

type RecentlySearchedProps = {
  storeIdentifierName: StoreIdentifierName;
  handleShowPreSayt: (value: boolean) => void;
};

const RecentlySearched = ({ storeIdentifierName, handleShowPreSayt }: RecentlySearchedProps) => {
  const getRecentSearchTerms = () => {
    const terms = localStorage.getItem('recentTerms');
    return terms ? terms.split(',').filter((term) => term.trim() !== '') : [];
  };

  const [recentSearchData, setRecentSearchData] = useState(getRecentSearchTerms());

  const { submitSearch, getSearchTermUrl } = getSearchUtils(storeIdentifierName);

  const handleRemove = (
    index: string | number,
    keyword: string,
    event: React.MouseEvent<HTMLButtonElement, MouseEvent> | React.KeyboardEvent<HTMLButtonElement>,
  ) => {
    if (
      (event.type === 'keydown' &&
        ((event as React.KeyboardEvent<HTMLButtonElement>).key === NEW_KEY_CODES.ENTER ||
          (event as React.KeyboardEvent<HTMLButtonElement>).key === NEW_KEY_CODES.SPACE)) ||
      event.type === 'click'
    ) {
      event.stopPropagation();
      if (recentSearchData) {
        setRecentSearchData(
          recentSearchData.filter((searchTerm, searchIndex) => searchIndex !== index),
        );
      }
      multiUseAnalyticsEvent({ event: 'Remove Recently Searched', value: keyword });
    }
  };

  const handleAnalyticsEvent = () => {
    setCookie('searchRefinement', 'recentlySearchedTerm');
  };

  const handleRecentSearchClick = (searchTerm: string) => {
    handleAnalyticsEvent();
    submitSearch(searchTerm, 'keyword');
  };

  useEffect(() => {
    localStorage.setItem('recentTerms', recentSearchData?.join(',') || '');
    handleShowPreSayt(recentSearchData?.length > 0);
  }, [recentSearchData]);

  return (
    <div className="recently-searched-container">
      {recentSearchData &&
        recentSearchData?.length > 0 &&
        recentSearchData.map((recentSearchTerm: string, index) => (
          <div
            className="hmf-display-flex hmf-align-items-center hmf-justify-content-between recent-search-item"
            key={`recently-searched-${recentSearchTerm}`}>
            <TextLink
              variant="group"
              size="small"
              className="hmf-display-flex hmf-align-items-center recent-search-link hmf-flex-grow"
              href={getSearchTermUrl(recentSearchTerm) ?? ''}
              aria-label={`Search for ${recentSearchTerm}`}
              onClick={() => handleRecentSearchClick(recentSearchTerm)}>
              <>
                <div>
                  <HomefieldIconTimeHistory height={16} width={16} />
                </div>
                <span className="hmf-body-l label-base hmf-pl-xxs">{recentSearchTerm}</span>
              </>
            </TextLink>
            <button
              type="button"
              className="remove-button-recently-searched hmf-p-xxxs"
              onClick={(event) => handleRemove(index, recentSearchTerm, event)}
              onKeyDown={(event) => handleRemove(index, recentSearchTerm, event)}
              aria-label={`Remove ${recentSearchTerm}`}>
              <HomefieldIconSignCancel width={16} height={16} />
            </button>
          </div>
        ))}
    </div>
  );
};

export default RecentlySearched;
